module.exports = __webpack_public_path__ + "assets/img/background-intro.jpg?hash=2849bea9e31a69c3927522b175fa1c9c";